import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalNotificationComponent } from 'src/app/shared/components/modal-notification/modal-notification.component';
import { PractitionerStatus } from 'src/app/shared/enums/practitioner-status.enum';
import { Practitioner } from 'src/app/shared/models/practitioner.model';
import { Status } from 'src/app/shared/models/status.model';
import { PractitionerService } from 'src/app/shared/services/practitioner.service';
import { StatusService } from 'src/app/shared/services/status.service';

@Component({
  selector: 'app-admin-practitioner-item',
  templateUrl: './admin-practitioner-item.component.html',
  styleUrls: ['./admin-practitioner-item.component.scss']
})
export class AdminPractitionerItemComponent implements OnInit {
  @Output() practitionerUpdated = new EventEmitter<void>();
  @ViewChild('confirmation') confirmationModal: ModalNotificationComponent;
  @Input() practitioner: Practitioner;
  currentWindowWidth: number;
  selectedPractitionerId: string;
  actions: { canApprove: boolean, canConditionallyApprove: boolean, canReject: boolean, canApprovePendingUpdates: boolean } = {
    canApprove: false,
    canConditionallyApprove: false,
    canReject: false,
    canApprovePendingUpdates: false
  };

  get isMobileScreen(): boolean {
    return this.currentWindowWidth <= 420;
  }

  get statusReference(): typeof PractitionerStatus {
    return PractitionerStatus;
  }

  constructor(private statusService: StatusService, private practitionerService: PractitionerService) { }

  ngOnInit(): void {
    this.currentWindowWidth = window.innerWidth;
    if (this.practitioner) {
      switch(this.practitioner.status) {
        case PractitionerStatus.Approved:
          this.actions.canApprove = false;
          this.actions.canConditionallyApprove = false;
          this.actions.canReject = false;
          break;
        case PractitionerStatus.ApprovedConditionally:
          this.actions.canApprove = true;
          this.actions.canConditionallyApprove = false;
          this.actions.canReject = false;
          break;
        case PractitionerStatus.PendingApproval:
          this.actions.canApprove = true;
          this.actions.canConditionallyApprove = true;
          this.actions.canReject = true;
          break;
      }
    }
  }

  openModal(type: PractitionerStatus, practitionerId: string) {
    this.selectedPractitionerId = practitionerId;
    this.confirmationModal.includeDetail = false;
    switch (type) {
      case PractitionerStatus.Approved:
        this.confirmationModal.open(
          'Approve Practitioner',
          'Are you sure you want to approve this practitioner?',
          'Cancel',
          PractitionerStatus.Approved
        );
        break;
      case PractitionerStatus.ApprovedConditionally:
        this.confirmationModal.includeDetail = true;
        this.confirmationModal.open(
          'Approve Practitioner with Conditions',
          'Are you sure you want to approve this practitioner with conditions? Please list your reasons.',
          'Cancel',
          PractitionerStatus.ApprovedConditionally
        );
        break;
      case PractitionerStatus.Rejected:
        this.confirmationModal.open(
          'Reject Practitioner',
          'Are you sure you want to reject this practitioner?',
          'Cancel',
          PractitionerStatus.Rejected
        );
        break;
    }
  }

  modalSubmitted(type: { action: PractitionerStatus, detail: string }) {
    var description = 'Application has been ' + type.action;
    var status = type.action;
    var newStatus = new Status(
      new Date().getTime(), description, status, this.selectedPractitionerId
    );
    this.statusService.createStatus(newStatus, this.practitioner, type.detail).then(_ => {
      this.confirmationModal.includeDetail = false;
      this.confirmationModal.open(status, 'Practitioner application has been ' + status, 'Okay');
      this.practitionerUpdated.emit();
    });
  }

  approvePendingUpdates(type: { action: PractitionerStatus, detail: string }) {
    var description = 'Practitioner updates have been approved.';
    var status = PractitionerStatus.Approved;
    var newStatus = new Status(
      new Date().getTime(), description, status, this.selectedPractitionerId
    );
    this.practitionerService.approvePractitionerPendingUpdates(this.practitioner).then(_ => {
      this.statusService.createStatus(newStatus, this.practitioner, type.detail).then(_ => {
        this.confirmationModal.includeDetail = false;
        this.confirmationModal.open(status, 'Practitioner updates have been approved', 'Okay');
        this.practitionerUpdated.emit();
      });
    }, error => {
      alert(error);
    })
  }

  @HostListener('window:resize')
  onResize() {
    this.currentWindowWidth = window.innerWidth;
  }
}
